// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1z-0";
export var spinnerContainer = "_1z-1";